// This enum contains the modes for adding an event in the dialog
export enum DialogMode {
   add,
   edit
}
